export const STATUS_OPTIONS = [
  { name: "All", value: -1 },
  { name: "Active", value: 1 },
  { name: "Inactive", value: 0 },
];

export const CUSTOMER_STATUS_OPTIONS = [
  { name: "All", value: -1 },
  { name: "Active", value: 1 },
  { name: "Blocked", value: 0 },
  { name: "Deleted", value: 2 },
];

export const ORDER_BY_OPTIONS = [
  { name: "Ascending", value: 1 },
  { name: "Descending", value: -1 },
];

export const PLAN_TYPES = [
  { name: "Unlimited", value: "unlimited" },
  { name: "Single Wash", value: "single_wash" },
];

export const PLAN_OPTIONS = [
  { name: "Single Wash", value: "single_wash" },
  { name: "Unlimited", value: "unlimited" },
];

export const BILLING_CYCLE = [
  { name: "One Time", value: "onetime" },
  { name: "Monthly", value: "monthly" },
  { name: "Half Yearly", value: "half_yearly" },
  { name: "Yearly", value: "yearly" },
];

export const FREE_WASH_RULES_OPTIONS = [
  { name: "Per Vehicle", value: "PER_VEHICLE" },
  { name: "Per Account", value: "PER_ACCOUNT" },
];

export const PAYMENT_STATUS = [
  { name: "Pending", value: 0 },
  { name: "Paid", value: 1 },
  { name: "Refunded", value: 2 },
  { name: "Failed", value: 3 },
];

export const CUSTOMER_MEMBERSHIP_STATUS = [
  { name: "Deactivated", value: -1 },
  { name: "Pending", value: 0 },
  { name: "Active", value: 1 }, // Running state
  { name: "Completed", value: 2 }, // if user purchase single wash or enrolled with get free wash
  { name: "Cancelled", value: 3 },
  { name: "Overridden", value: 4 }, // override mean like free to paid
  { name: "Hold", value: 5 },
  { name: "Paused", value: 6 },
  { name: "Past Due", value: 7 },
];

export const WASH_HISTORY_STATUS = [
  { name: "Initiated", value: "INITIATED", className: "initiated" },
  { name: "Created", value: "CREATED", className: "created" },

  {
    name: "Exterior Queued",
    value: "EXTERIOR_QUEUED",
    className: "exterior_queued",
  },
  {
    name: "Exterior Entered",
    value: "EXTERIOR_ENTERED",
    className: "exterior_entered",
  },
  {
    name: "Exterior Started",
    value: "EXTERIOR_STARTED",
    className: "exterior_started",
  },
  {
    name: "Exterior Finished",
    value: "EXTERIOR_FINISHED",
    className: "exterior_finished",
  },

  {
    name: "Interior Entered",
    value: "INTERIOR_ENTERED",
    className: "interior_entered",
  },
  {
    name: "Interior Started",
    value: "INTERIOR_STARTED",
    className: "interior_started",
  },
  {
    name: "Interior Finished",
    value: "INTERIOR_FINISHED",
    className: "interior_finished",
  },

  {
    name: "Emergency Exit",
    value: "EMERGENCY_EXIT",
    className: "emergency_exit",
  },

  { name: "Completed", value: "COMPLETED", className: "active" },
  { name: "Cancelled", value: "CANCELLED", className: "inactive" },
  { name: "Aborted", value: "ABORTED", className: "inactive" },
  { name: "Failed", value: "FAILED", className: "inactive" },
];

export const WEEK_DAYS = [
  { name: "Sunday", value: "Sunday" },
  { name: "Monday", value: "Monday" },
  { name: "Tuesday", value: "Tuesday" },
  { name: "Wednesday", value: "Wednesday" },
  { name: "Thursday", value: "Thursday" },
  { name: "Friday", value: "Friday" },
  { name: "Saturday", value: "Saturday" },
];

export const WASH_TYPES = [
  { name: "Membership", value: "MEMBERSHIP" },
  { name: "Single", value: "SINGLE" },
  { name: "Free", value: "FREE" },
  { name: "Trial", value: "TRIAL" },
];

export const NOTIFICATION_STATUS = [
  { name: "Pending", value: "pending", className: "pending" },
  { name: "Sent", value: "sent", className: "active" },
  { name: "Opened", value: "open", className: "active" },
];

export const NOTIFICATION_TYPE = [
  { name: "All", value: "all" },
  { name: "Specific Customers", value: "specific_customers" },
];

export const OPERATOR_OPTIONS = [
  // { name: "None", value: "NONE" },
  { name: "Equals", value: "EQUALS" },
  { name: "Not Equals", value: "NOT_EQUALS" },
  { name: "Greater Than", value: "GT" },
  { name: "Greater Than or Equal", value: "GTE" },
  { name: "Less Than", value: "LT" },
  { name: "Less Than or Equal", value: "LTE" },
  { name: "In", value: "IN" },
  { name: "Between", value: "BETWEEN" },
];

export const UNIT_OPTIONS = [
  // { name: "None", value: "NONE" },
  // { name: "Minutes", value: "MINUTES" },
  // { name: "Hours", value: "HOURS" },
  { name: "Days", value: "DAYS" },
];

export const AUDIENCE_TYPES = [
  { name: "Segments", value: "SEGMENT" },
  { name: "Custom Conditions", value: "CUSTOM" },
];
export const API_LOGS_RESPONSE_OPTIONS = [
  { name: "All", value: 0 },
  { name: "Status Code 200", value: 200 },
  { name: "Status Code 400", value: 400 },
];
export const API_LOGS_STATUS_OPTION = [
  { name: "All", value: -1 },
  { name: "Success", value: 1 },
  { name: "Failure", value: 0 },
];
export const PLATFORM_OPTIONS = [
  { name: "All", value: "" },
  { name: "Android", value: "android" },
  { name: "iOS", value: "iOS" },
  { name: "Web", value: "web" },
];
export const COUPON_VISIBILITY = [
  { name: "All", value: "" },
  { name: "Public", value: "public" },
  { name: "Private", value: "private" },
];
export const COUPON_FORM_VISIBILITY = [
  { name: "Public", value: "public" },
  { name: "Private", value: "private" },
];
export const COUPON_DISCOUNT_TYPE = [
  { name: "Fixed", value: "fixed" },
  { name: "Percentage", value: "percentage" },
];
export const SEGMENTS_BY_CATEGORY = {
  USER: [
    {
      name: "Single Vehicle",
      value: "SINGLE_VEHICLE",
      config: { count: 1 },
    },
    {
      name: "Multiple Vehicle",
      value: "MULTIPLE_VEHICLE",
      config: { count: 1 },
    },
    {
      name: "One Time Customers",
      value: "ONE_TIME_CUSTOMERS",
      config: { days: 30 },
    },
    {
      name: "Repeat Customers",
      value: "REPEAT_CUSTOMERS",
      config: { days: 30 },
    },
    {
      name: "No Active Plan Users",
      value: "BIRTHDAY",
    },
    {
      name: "Birthday",
      value: "BIRTHDAY",
    },
    {
      name: "Account Created",
      value: "ACCOUNT_CREATED",
    },
  ],

  WASH: [
    {
      name: "Inactive Customers",
      value: "INACTIVE_CUSTOMERS",
      config: { days: 30 },
    },
    {
      name: "No Wash Since",
      value: "NO_WASH_SINCE",
      config: { days: 30 },
    },
    {
      name: "Dormant Customers",
      value: "DORMANT_CUSTOMERS",
      config: { minDays: 30, maxDays: 90 },
    },
  ],

  MEMBERSHIP: [
    {
      name: "Expiring Soon",
      value: "EXPIRING_SOON",
      config: { days: 7 },
    },
    {
      name: "Expired Members",
      value: "EXPIRED_MEMBERS",
    },
    {
      name: "Active Members",
      value: "ACTIVE_MEMBERS",
    },
    {
      name: "Membership On Hold",
      value: "MEMBERSHIP_ON_HOLD",
    },
    {
      name: "Only Exterior Members",
      value: "ONLY_EXTERIOR_MEMBERS",
    },
    {
      name: "Add on Promotions",
      value: "ADD_ON_PROMOTION",
    },
    {
      name: "Membership Purchased",
      value: "MEMBERSHIP_PURCHASED",
    },
  ],

  ENGAGEMENT: [
    {
      name: "New Customers",
      value: "NEW_CUSTOMERS",
    },
    {
      name: "Active Customers",
      value: "ACTIVE_CUSTOMERS",
      config: { days: 30 },
    },
  ],
  STORE: [
    {
      name: "Store Nearby Users",
      value: "STORE_NEARBY_USERS",
      config: { radiusInKm: 10 },
    },
  ],
};

export const LOGICAL_OPERATORS = [
  { name: "AND", value: "AND" },
  { name: "OR", value: "OR" },
];
export const TYPE_LABELS = {
  number: "Number",
  boolean: "Boolean",
  date: "Date",
  string: "Text",
  select: "Select",
  plan: "Plan",
};
export const MEMBERSHIP_STATUS = [
  { name: "Active", value: "1" },
  { name: "Expired", value: "2" },
  { name: "Cancelled", value: "3" },
  { name: "Hold", value: "5" },
  { name: "Paused", value: "6" },
];
export const NUMBER_OPS = [
  "EQUALS",
  "NOT_EQUALS",
  "GT",
  "GTE",
  "LT",
  "LTE",
  "BETWEEN",
];
const DATE_OPS = ["EQUALS", "GT", "GTE", "LT", "LTE", "BETWEEN"];
const BOOL_OPS = ["EQUALS", "NOT_EQUALS"];
const SELECT_OPS = ["EQUALS", "NOT_EQUALS"];
export const EVENT_CONFIG = {
  exteriorWashCount: {
    label: "Exterior Wash Count",
    type: "number",
    operators: NUMBER_OPS,
    default: { operator: "GTE", value: 0 },
  },
  interiorWashCount: {
    label: "Interior Wash Count",
    type: "number",
    operators: NUMBER_OPS,
    default: { operator: "EQUALS", value: 0 },
  },
  washCount: {
    label: "Wash Count",
    type: "number",
    operators: NUMBER_OPS,
    default: { operator: "BETWEEN", value: 1 },
  },
  vehicleCount: {
    label: "Vehicle Count",
    type: "number",
    operators: NUMBER_OPS,
    default: { operator: "EQUALS", value: 1 },
  },
  daysSinceLastWash: {
    label: "Days Since Last Wash",
    type: "number",
    operators: NUMBER_OPS,
    default: { operator: "GTE", value: 10 },
  },
  hasActivePlan: {
    label: "Has Active Plan",
    type: "boolean",
    operators: BOOL_OPS,
    default: { operator: "NOT_EQUALS", value: true },
  },
  membershipHasAddon: {
    label: "Membership Has Addon",
    type: "boolean",
    operators: BOOL_OPS,
    default: { operator: "EQUALS", value: false },
  },
  lastWashDate: {
    label: "Last Wash Date",
    type: "date",
    operators: DATE_OPS,
    default: { operator: "BETWEEN", value: "" },
  },
  membershipPlanType: {
    label: "Membership Plan Type",
    type: "select",
    operators: SELECT_OPS,
    options: PLAN_TYPES,
    default: { operator: "EQUALS", value: "unlimited" },
  },
  membershipPlanId: {
    label: "Membership Plan",
    type: "plan",
    operators: SELECT_OPS,
    default: { operator: "EQUALS", value: "" },
  },
  membershipStatus: {
    label: "Membership Status",
    type: "select",
    operators: SELECT_OPS,
    options: MEMBERSHIP_STATUS,
    default: { operator: "EQUALS", value: "1" },
  },
};

export const ADMIN_ACCOUNT_TYPE = [
  { name: "Admin", value: "admin" },
  { name: "Staff", value: "staff" },
];
export const CAMERA_ROLE_TYPE = [
  { name: "Entry", value: "ENTRY" },
  { name: "Exit", value: "EXIT" },
  { name: "Interior Entry", value: "INTERIOR_ENTRY" },
  { name: "Interior Exit", value: "INTERIOR_EXIT" },
  { name: "Emergency Exit", value: "EMERGENCY_EXIT" },
];

export const REWARD_TRIGGERING_TYPES_SENDER = [
  { name: "Receiver First Transaction", value: "receiverFirstTransaction" },
  { name: "Receiver Sign Up", value: "receiverSignup" },
];

export const REWARD_TRIGGERING_TYPES_RECEIVER = [
  { name: "Sign Up", value: "signup" },
];
export const MAXIMUM_VALUES_MAX_TRANSFER_AND_MAX_PAUSES = [
  { name: "1", value: 1 },
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
];

export const DYNAMIC_PRICES_TYPES = [
  { name: "Fixed", value: "fixed" },
  { name: "Percentage", value: "percentage" },
];
export const MEMBERSHIP_PAUSE_BILLING_CYCLE = [
  { name: "Monthly", value: "monthly" },
  { name: "Half Yearly", value: "half_yearly" },
  { name: "Yearly", value: "yearly" },
];
export const REFERRAL_TYPE_OPTIONS = [
  { name: "Collect", value: "collect" },
  { name: "Redeem", value: "redeem" },
  { name: "Cancel", value: "cancel" },
];
export const REFERRAL_SOURCE_OPTIONS = [
  { name: "Referral", value: "referral" },
  { name: "Booking", value: "booking" },
  { name: "Admin", value: "admin" },
  { name: "Promo", value: "promo" },
];
export const REFERRAL_CODE_USAGE_TYPE = [
  { name: "Used", value: true },
  { name: "Not Used", value: false },
];
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
